import { render, staticRenderFns } from "./AccountSettingPayment.vue?vue&type=template&id=047806c1"
import script from "./AccountSettingPayment.vue?vue&type=script&lang=js"
export * from "./AccountSettingPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports